import { FolderOutlined, StarFilled } from "@ant-design/icons"
import { Button, Card, Col, Flex, Row, Tag, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { ActionTooltip } from "../../../../components/ActionTooltip.tsx"
import {
  brand,
  neutral,
  semantic
} from "../../../../components/widgets/tokens.ts"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { useDateFormatter } from "../../../../hooks/use-date-formatter.tsx"
import { useFavoriteReports } from "../../hooks/useFavoriteReports.ts"

const { Title, Text } = Typography

export const HomeFavoriteReports = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { formatDate } = useDateFormatter()
  const { reports, unfavorite } = useFavoriteReports()

  if (reports.length === 0) return null

  return (
    <Flex vertical gap="middle">
      <Title level={5} className="m-0">
        {t("reports.home.favoritesTitle")}
      </Title>
      <Row gutter={[16, 16]}>
        {reports.map((report) => (
          <Col key={report.id} xs={24} sm={12} xl={6}>
            <Card
              hoverable
              variant="borderless"
              classNames={{ body: "p-4" }}
              onClick={() => navigate(RoutesPaths.reports.view(report.id))}
            >
              <Flex vertical gap={8}>
                <Flex align="start" justify="space-between" gap="small">
                  <Text
                    strong
                    ellipsis={{ tooltip: report.name }}
                    style={{ color: brand.teal }}
                  >
                    {report.name}
                  </Text>
                  <ActionTooltip title={t("reports.actions.unfavorite")}>
                    <Button
                      type="text"
                      size="small"
                      aria-label={t("reports.actions.unfavorite")}
                      onClick={(e) => {
                        e.stopPropagation()
                        void unfavorite(report)
                      }}
                      icon={<StarFilled style={{ color: semantic.star }} />}
                    />
                  </ActionTooltip>
                </Flex>
                <Flex align="center" gap="small" wrap="wrap">
                  {report.folder && (
                    <Tag icon={<FolderOutlined />} bordered={false}>
                      {report.folder}
                    </Tag>
                  )}
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {t("reports.home.widgets", { count: report.widget_count })}
                  </Text>
                </Flex>
                <Text style={{ fontSize: 12, color: neutral.faint }}>
                  {t("reports.home.updated", {
                    date: formatDate(report.updated_at)
                  })}
                </Text>
              </Flex>
            </Card>
          </Col>
        ))}
      </Row>
    </Flex>
  )
}
